/*
 * Layout for the Response styles
 */
define(["marionette", "./template/responseStylesTemplate.html"], function (
  Marionette,
  ResponseStylesTemplate,
) {
  const ResponseStylesView = {
    responseStylesLayout: Marionette.Layout.extend({
      template: ResponseStylesTemplate,
      ui: {
        customStyles: "#customStyles",
        defaultStyles: "#defaultStyles",
        visibleResponseStylesGroup: "#visibleResponseStylesGroup",
        hiddenResponseStylesGroup: "#hiddenResponseStylesGroup",
      },
      triggers: {
        "click #hiddenResponseStylesGroup .toggle-button": "toggleDefaultResponseStyles",
        "click #visibleResponseStylesGroup .toggle-button": "toggleDefaultResponseStyles",
      },
      getCustomStyles: function () {
        const value = this.ui.customStyles.val();
        const trimmedValue = value.trim();
        if (value !== trimmedValue) {
          this.ui.customStyles.val(trimmedValue);
        }
        return trimmedValue;
      },
      setDefaultStyles: function (defaultStyles) {
        this.ui.defaultStyles.val(defaultStyles);
      },
      showDefaultResponseStyles: function () {
        this.ui.visibleResponseStylesGroup.removeClass("hidden");
        this.ui.hiddenResponseStylesGroup.addClass("hidden");
      },
      hideDefaultResponseStyles: function () {
        this.ui.hiddenResponseStylesGroup.removeClass("hidden");
        this.ui.visibleResponseStylesGroup.addClass("hidden");
      },
    }),
  };

  return ResponseStylesView;
});
